import {electron} from './global'

export * from './global'

export default electron
